import { Feed } from '@mui/icons-material';

const API_URLS = {
  BASE: process.env.REACT_APP_API_URL,
  URL: {
    login: 'token',
    refreshToken: '/token/refresh',
    forgotPassword: 'account/recovery/initiate',
    resetPassword: 'account/recovery/finalize',
    createUser: 'user',
    getUser: 'user/me',
    updateUser: 'user/:user_id',
    changePassword: 'user/password',
    getUserList: 'user/filter',
    uploadUserProfile: 'user/uploadfile',

    farmer: 'farmer',
    getFarmer: 'farmer/filter',
    getFarmerDetailsById: 'farmer/:farmer_id',
    updateFarmer: 'farmer/:farmer_id',
    uploadFarmerProfile: 'farmer/uploadfile',

    supplier: 'suppliers',
    getSupplierList: '/suppliers/filter',
    getSupplier: '/suppliers/:id',
    updateSupplier: '/suppliers/:id',
    deleteSupplier: '/suppliers/:id',
    uploadFile: '/suppliers/uploadfile',
    delete: '/suppliers/:id',

    molasses: '/molasses',
    getMolassesList: '/molasses/filter',
    getMolasses: '/molasses/:id',
    updateMolasses: 'molasses/:id',
    getFermentationOptions: '/molasses/sendToFermentation',
    sendToFermentationMolasses: '/molasses/sendToFermentation',
    removeMolassesFermentation: '/molasses/removeFermentation/:id',

    farminspection: 'farminspection',
    updateFarminspection: 'farminspection/:inspection_id',
    getInspectionList: 'farminspection/filter',
    harvesting: 'harvesting',
    getHarvestingReqList: 'harvesting/filter',
    updateHarvesting: 'harvesting/:harvesting_id',
    sendToFermentation: 'harvesting/sendToFermentation',

    fermentation: 'fermentation',
    getFermentation: 'fermentation/filter',
    getFarmentationDetailsById: 'fermentation/:fermentation_id',
    updateFarmentation: 'fermentation/:fermentation_id',
    getTankDetailsById: 'fermentation/tank-details/:item_id',
    chemistrylogs: 'chemistrylogs',
    getChemistryLogsList: 'chemistrylogs/filter',
    updateChemistryLogs: 'chemistrylogs/:chemistry_logs_id',
    getTankList: 'tank/filter',

    stripping: {
      processList: '/strippingprocess/filter',
      createProcess: '/strippingprocess',
      processById: '/strippingprocess/:id',
      processData: 'strippingdata/filter',
      addProcessData: 'strippingdata',
      processDataById: 'strippingdata/:id',
      getProcessDataById: 'strippingdata/:id',
      sendToStrippingProcess: 'strippingprocess/associate',
      addWasteWaterData: 'strippingwastewaterdata',
      updateWasteWater: '/strippingwastewaterdata/:id',
      getWasteWaterList: '/strippingwastewaterdata/filter',
      addStrippingSubLogData: 'strippingsublogs',
      updateStrippingSubLog: '/strippingsublogs/:id',
      deleteStrippingSubLog: '/strippingsublogs/:id',
      getStrippingSubLogList: '/strippingsublogs/filter',
    },

    spirit: {
      createSpirit: 'spiritprocess',
      getSpiritList: 'spiritprocess/filter',
      getSpiritById: 'spiritprocess/:id',
      updateSpiritById: 'spiritprocess/:id',
      getSpiritLogsList: 'spiritlogsdata/filter',
      createSpiritLogs: 'spiritlogsdata',
      updateSpiritLogs: 'spiritlogsdata/:id',
      deleteSpiritLogs: 'spiritlogsdata/:id',
      addWasteWaterData: 'spiritwastewaterdata',
      updateWasteWater: 'spiritwastewaterdata/:id',
      getWasteWaterList: 'spiritwastewaterdata/filter',
      sendToSpiritProcess: 'spiritprocess/associate',
      getEndOfRunCut: 'endOfRunCut/:spiritProcessId',
      saveEndOfRunCut: 'endOfRunCut/',
      getEndOfRunCutById: 'endOfRunCut/getbyid/:id',
      updateEndOfRunCut: 'endOfRunCut/:id',
    },

    proofing: {
      getProofingList: 'proofing/filter',
      createProofing: 'proofing',
      updateProofing: 'proofing/:id',
      deleteProofing: 'proofing/:id',
      sendToProofing: 'proofing/associate',
      getSpiritListAssociateProofing: '/proofing/associate/list',
      unlinkSpiritWithProofing: '/proofing/unlink/spiritlogs',
    },

    caskandaging: {
      getCaskAndAgingList: 'caskandaging/filter',
      createCaskAndAging: 'caskandaging',
      updateCaskAndAging: 'caskandaging/:id',
      getCaskAndAgingById: 'caskandaging/:id',
      getSamplinglogsList: 'caskandagingsamplinglogs/filter',
      createSamplinglogs: 'caskandagingsamplinglogs',
      updateSamplinglogs: 'caskandagingsamplinglogs/:id',
      getCaskOpenLogsList: 'caskandagingcaskopenlogs/filter',
      createCaskOpenLogs: 'caskandagingcaskopenlogs',
      updateCaskOpenLogs: 'caskandagingcaskopenlogs/:id',
      getCaskOpenLogsById: 'caskandagingcaskopenlogs/:id',
      deleteCaskOpenLogs: 'caskandagingcaskopenlogs/:id',
    },

    caskmaster: {
      getCaskMasterList: 'cask/filter',
      createCaskMaster: 'cask',
      updateCaskMaster: 'cask/:id',
    },

    bottling: {
      getBottlingList: 'bottling/filter',
      createBottling: 'bottling',
      updateBottling: 'bottling/:id',
      getBottlingSubList: 'bottlingdata/filter',
      deleteBottleFromSubList: 'bottlingdata/:id',
    },
    canevariety: {
      getCaneCarietyList: 'canevariety/filter',
      createCaneVariety: 'canevariety',
      updateCaneVariety: 'canevariety/:id',
    },
    rumtypesampling: {
      getRumTypeList: 'rumTypeSampling/filter',
      createRumType: 'rumTypeSampling',
      updateRumType: 'rumTypeSampling/:id',
      deleteRumType: 'rumTypeSampling/:id',
    },
    nutrients: {
      getNutrientsList: 'nutrients/filter',
      createNutrients: 'nutrients',
      updateNutrients: 'nutrients/:id',
      deleteNutrients: 'nutrients/:id',
    },
    bottle: {
      getBottleDetail: 'bottle/:bottle_no',
    },
    Feedback: {
      createFeedback: 'feedback/:bottle_no',
    },
    Quicksight: {
      getQuicksightEmbedUrl: 'quicksight/embed',
    },
    guests: {
      getGuestsList: 'guests/filter',
      createGuest: 'guests/',
    },
    settings: 'settings',
    aiAssistantToken: 'ai-assistant/token',
    tanksVessel: 'tanksVessel',
    batchPassport: 'batch-passport/:batch_no',
  },
};
export default API_URLS;
